<script setup>
import ModalBox from './ModalBox.vue'
import FormButton from '../Atoms/FormButton.vue'

defineProps({
	message: {
		type: String,
		default: '',
	},
	body: {
		type: String,
		default: '',
	},
	okText: {
		type: String,
		default: 'OK',
	},
})

const isVisible = defineModel('isVisible', { type: Boolean, default: false })

const dismiss = () => {
	isVisible.value = false
}
</script>

<template>
	<ModalBox v-model="isVisible" size="sm" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none">
		<div class="px-6 pt-6 text-surface-text-2">
			{{ message }}
		</div>
		<div v-if="body" class="px-6 pt-2 text-surface-7 text-sm">
			{{ body }}
		</div>
		<template #footer>
			<div class="flex p-6 justify-end">
				<FormButton size="md" @click="dismiss">
					{{ okText }}
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>
